import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32 0H0V32H32V0Z",
      class: "bg",
      fill: "#ECD3FE"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.08 21.5066H14.4133C14.2353 21.5031 14.0658 21.4299 13.9411 21.3028C13.8164 21.1756 13.7466 21.0047 13.7467 20.8266V18.8133C13.7088 17.7404 14.0485 16.6882 14.7067 15.8399C15.4 15.0133 16.04 15.0266 17.1067 13.7999C17.6145 13.3087 17.9747 12.6852 18.1467 11.9999C18.2142 11.6531 18.2024 11.2955 18.1124 10.9538C18.0224 10.6121 17.8563 10.2952 17.6267 10.0266C17.3022 9.6899 16.8772 9.46757 16.4156 9.39304C15.954 9.3185 15.4806 9.39579 15.0667 9.61328C14.7382 9.79439 14.4556 10.0484 14.2406 10.3558C14.0256 10.6633 13.884 11.0159 13.8267 11.3866C13.8044 11.541 13.7276 11.6823 13.6103 11.785C13.4929 11.8877 13.3426 11.945 13.1867 11.9466H10.7467C10.12 11.9466 9.81333 11.6399 9.82666 11.2799C9.89947 9.64949 10.6095 8.1128 11.804 7.00063C12.9985 5.88845 14.5818 5.28971 16.2133 5.33328C17.9153 5.41835 19.5152 6.17042 20.6667 7.42661C21.1116 7.91201 21.4681 8.47157 21.72 9.07994C22.3544 10.6678 22.3544 12.4387 21.72 14.0266C21.0721 15.6043 19.955 16.9449 18.52 17.8666C18.2305 18.0094 17.9961 18.2437 17.8533 18.5333C17.8468 18.6576 17.8468 18.7823 17.8533 18.9066C17.8533 19.5599 17.8533 20.2399 17.8533 20.8399C17.8546 20.9372 17.8345 21.0336 17.7946 21.1223C17.7546 21.2111 17.6957 21.29 17.622 21.3535C17.5483 21.417 17.4616 21.4636 17.368 21.4901C17.2743 21.5166 17.176 21.5222 17.08 21.5066Z",
      class: "primary",
      fill: "#AD44FC"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.7467 26.667C16.8512 26.667 17.7467 25.7716 17.7467 24.667C17.7467 23.5624 16.8512 22.667 15.7467 22.667C14.6421 22.667 13.7467 23.5624 13.7467 24.667C13.7467 25.7716 14.6421 26.667 15.7467 26.667Z",
      class: "primary",
      fill: "#AD44FC"
    }, null, -1)
  ])))
}
export default { render: render }